module.exports = __webpack_public_path__ + "img/Property 1=icon005.fce69160.svg";